import React from "react";
const IconHeartPath = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    {...props}
  >
    <clipPath id="heart-path" clipPathUnits="objectBoundingBox">
      <path
        d="m 0.5351 0.2592 c 0.0065 -0.0107 0.0138 -0.0205 0.0219 -0.0293 c 0.067 -0.0732 0.1753 -0.0732 0.2423 0 c 0.0677 0.074 0.0677 0.1944 0 0.2683 l -0.2993 0.3269 l -0.2993 -0.3268 c -0.0677 -0.074 -0.0677 -0.1944 0 -0.2683 c 0.067 -0.0733 0.1753 -0.0733 0.2423 0 c 0.0081 0.0088 0.0154 0.0185 0.0219 0.0292 l 0.0351 0.0575 l 0.0351 -0.0575 z"
        fill="currentColor"
      />
    </clipPath>
  </svg>
);
export default IconHeartPath;
